import {
  errorLoading, loading, loaded, responseHandler, errorGetStatus,
  tokenInterceptor
} from '../manager/HttpManager'
import { fetchLogoutAction } from './AuthWS'
import Constants from '../constants/Constants'

let urlServer = Constants.UrlsConstants.urlServer

let pagePoi = 1
let maxPagePoi = 1
let limitPoi = 100
let isFetchingDatasPoi = false
let searchPoi = null

export const mapWS = (state = { maps: [], types: [], mapWizeVenues: [] }, action) => {
  switch (action.type) {
    case Constants.ActionsConstants.MAP.SET_MAPS:
      return Object.assign({}, state, { maps: action.datas })
    case Constants.ActionsConstants.MAP.SET_LIST_MAPS:
      return Object.assign({}, state, { maps: state.maps.concat(action.datas.content) })
    case Constants.ActionsConstants.MAP.RESET_MAPS:
      return Object.assign({}, state, { maps: [] })
    case Constants.ActionsConstants.MAP.SET_TYPES:
      return Object.assign({}, state, { types: action.datas })
    case Constants.ActionsConstants.MAP.SET_VENUES:
      return Object.assign({}, state, { mapWizeVenues: action.datas })
    default:
      return state
  }
}

export const setMaps = (data) => {
  return {
    type: Constants.ActionsConstants.MAP.SET_MAPS,
    datas: data,
  }
}

export const setListMaps = (data) => {
  return {
    type: Constants.ActionsConstants.MAP.SET_LIST_MAPS,
    datas: data,
  }
}

export const resetMaps = () => {
  return {
    type: Constants.ActionsConstants.MAP.RESET_MAPS,
  }
}

export function mapCalls(dispatch, poi, appid, file = null, locale = null, type, category, search, reset) {
  function clearPoiList() {
    // dispatch(setMaps({content: []}))
    pagePoi = 1
    maxPagePoi = 1
    limitPoi = 100
    isFetchingDatasPoi = false
    dispatch(resetMaps())
  }

  function fetchCategoryPoiList() {
    clearPoiList()
    let entryPoint = Constants.UrlsConstants.mapEntryPoint
    let method = Constants.MethodsWSConstants.MAP.FETCH_POIS_CATEGORY + appid + '/' + category
    fetch(urlServer + entryPoint + method + '?sort=id&dir=DESC', {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setMaps(data))
      })
      .catch(error => {
        // dispatch(clearStatus())
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function fetchPoiList() {
    if (search === undefined) {
      search = null
    }
    if (reset) {
      clearPoiList()
      searchPoi = search
    }
    if (pagePoi <= maxPagePoi && !isFetchingDatasPoi) {
      isFetchingDatasPoi = true
      let entryPoint = Constants.UrlsConstants.mapEntryPoint
      let method = Constants.MethodsWSConstants.MAP.FETCH_POIS + appid + '/' + type + '?page=' + pagePoi + '&size=' +
        limitPoi + '&sort=id&dir=DESC'
      if (pagePoi <= maxPagePoi) {
        if (search) {
          method = method + '&search=' + search
        }
        fetch(urlServer + entryPoint + method, {
          method: 'GET',
          headers: Constants.UrlsConstants.header,
        })
          .then(response => {
            tokenInterceptor(response)
            return responseHandler(response)
          })
          .then(r => r.json())
          .then(data => {
            if (search === searchPoi) {
              maxPagePoi = data.totalPages
              if (maxPagePoi >= pagePoi) pagePoi++
              isFetchingDatasPoi = false
              dispatch(setListMaps(data))
            }
            // dispatch(clearStatus())
          })
          .catch(error => {
            // dispatch(clearStatus())
            if (errorGetStatus(error) === 401) {
              dispatch(errorLoading('Error.Croutons.authExpired'))
              fetchLogoutAction(dispatch).fetchLogout()
            }
          })
      }
    }
  }

  function deletePoi() {
    let method = Constants.UrlsConstants.mapEntryPoint + Constants.MethodsWSConstants.MAP.DELETE + appid + '/' + poi.id

    fetch(urlServer + method, {
      method: 'DELETE',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.deleteSuccess'))
        resetPoiListPage()
        fetchPoiList()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.deleteError'))
        }
      })
  }

  function savePoi() {
    let method = Constants.UrlsConstants.mapEntryPoint + Constants.MethodsWSConstants.MAP.UPDATE + appid
    if (!poi.id) {
      method = Constants.UrlsConstants.mapEntryPoint + Constants.MethodsWSConstants.MAP.SET + appid
    }

    fetch(urlServer + method, {
      method: poi.id ? 'PUT' : 'POST',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify(poi),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        resetPoiListPage()
        fetchPoiList()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function uploadPois() {
    if (file && appid && locale) {
      let entryPoint = Constants.UrlsConstants.mapEntryPoint
      let method = Constants.MethodsWSConstants.MAP.SET + 'csv/' + appid
      let formData = new FormData()
      formData.append('login', Constants.UrlsConstants.header.login)
      formData.append('file', file)
      formData.append('locale', locale)

      let headers = {
        'authtoken': Constants.UrlsConstants.header.authtoken,
        'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
      }

      dispatch(loading(''))
      fetch(urlServer + entryPoint + method, {
        method: 'POST',
        body: formData,
        headers,
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        .then(r => r.json())
        .then(data => {
          if (data.error) {
            dispatch(errorLoading(data.error))
          } else {
            dispatch(loaded('Error.Croutons.uploadSuccess'))
          }
          resetPoiListPage()
          typesCalls(dispatch, appid, null).fetchTypes()
        })
        .catch(error => {
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
          } else {
            dispatch(errorLoading('Error.Croutons.uploadFail'))
          }
        })
    }
  }

  function resetPoiListPage() {
    pagePoi = 1
    maxPagePoi = 1
    limitPoi = 100
    isFetchingDatasPoi = false
    dispatch(resetMaps())
  }

  return {
    clearPoiList,
    fetchCategoryPoiList,
    fetchPoiList,
    deletePoi,
    savePoi,
    uploadPois,
    resetPoiListPage,
  }
}

export const setTypes = (data) => {
  return {
    type: Constants.ActionsConstants.MAP.SET_TYPES,
    datas: data,
  }
}

export function typesCalls(dispatch, appid, type, search) {
  function clearTypes() {
    dispatch(setTypes([]))
  }

  function fetchTypes() {
    let entryPoint = Constants.UrlsConstants.typesEntryPoint
    let method = Constants.MethodsWSConstants.MAP.FETCH_TYPES + appid + '?sort=label'

    fetch(urlServer + entryPoint + method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setTypes(data))
        mapCalls(dispatch).resetPoiListPage()
        if (data.length > 0) {
          mapCalls(dispatch, null, appid, null, null, data[0].id, search).fetchPoiList()
        }
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function saveType() {
    let method = Constants.UrlsConstants.typesEntryPoint + Constants.MethodsWSConstants.MAP.UPDATE + appid
    if (!type.id) {
      method = Constants.UrlsConstants.typesEntryPoint + Constants.MethodsWSConstants.MAP.SET + appid
    }

    fetch(urlServer + method, {
      method: type.id ? 'PUT' : 'POST',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify(type),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        fetchTypes()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function deleteType() {
    let method = Constants.UrlsConstants.typesEntryPoint + Constants.MethodsWSConstants.MAP.DELETE + appid + '/' + type.id

    fetch(urlServer + method, {
      method: 'DELETE',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.deleteSuccess'))
        fetchTypes()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.deleteError'))
        }
      })
  }

  return {
    clearTypes,
    fetchTypes,
    saveType,
    deleteType,
  }
}

export const setMapWizeVenues = (data) => {
  return {
    type: Constants.ActionsConstants.MAP.SET_VENUES,
    datas: data,
  }
}

export const setLinks = (data) => {
  return {
    type: Constants.ActionsConstants.MAP.SET_LINKS,
    datas: data,
  }
}

export function mapWizeCalls(dispatch, appid, venue, identifier, link) {
  function clearVenues() {
    dispatch(setMapWizeVenues([]))
  }

  function fetchVenues() {
    let entryPoint = Constants.UrlsConstants.mapWizeEntryPoint
    let method = Constants.MethodsWSConstants.MAP.VENUES +
      Constants.MethodsWSConstants.MAP.FETCH_VENUES + appid + '?sort=name'

    fetch(urlServer + entryPoint + method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setMapWizeVenues(data))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function saveVenue() {
    let method = Constants.UrlsConstants.mapWizeEntryPoint + Constants.MethodsWSConstants.MAP.VENUES + appid
    if (!venue.id) {
      method = Constants.UrlsConstants.mapWizeEntryPoint +
        Constants.MethodsWSConstants.MAP.VENUES + Constants.MethodsWSConstants.MAP.SET + appid
    }
    fetch(urlServer + method, {
      method: venue.id ? 'PUT' : 'POST',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify(venue),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        fetchVenues()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function deleteVenue() {
    let method = Constants.UrlsConstants.mapWizeEntryPoint + Constants.MethodsWSConstants.MAP.DELETE +
      Constants.MethodsWSConstants.MAP.VENUES + appid + '/' + venue.id

    fetch(urlServer + method, {
      method: 'DELETE',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.deleteSuccess'))
        fetchVenues()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.deleteError'))
        }
      })
  }

  return {
    clearVenues,
    fetchVenues,
    saveVenue,
    deleteVenue,
  }
}
